import React from "react";
import { Button } from "superbid-ui";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const Buttons = ({ styles, handleLogin, handleRegister, hidden }) => {
    return (
        <div className={styles.box__action} hidden={hidden}>
            <Button
                label="Entrar"
                template="orange"
                className={styles.box__action__button_login}
                onClick={() => handleLogin(true)}
            />
            <Button
                label="Cadastrar"
                template="orange_outline"
                className={styles.box__action__button_register}
                onClick={() => handleRegister(true)}
            />
        </div>
    );
};

export const ActionButtons = React.memo(Buttons);
